<script lang="ts" setup>
import { watch, onUnmounted } from 'vue'
import {useEscapeKey} from "@/composables/use-escape-key";

interface Props {
  isOpen: boolean
  onClose: () => void
}

const props = defineProps<Props>()

const disableScroll = () => {
  document.body.style.overflow = 'hidden'
  document.documentElement.style.overflow = 'hidden'
}

const enableScroll = () => {
  document.body.style.overflow = ''
  document.documentElement.style.overflow = ''
}

watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    disableScroll()
    return
  }
  enableScroll()
})

onUnmounted(enableScroll)

const handleOverlayClick = (event: MouseEvent) => {
  if (event.target !== event.currentTarget || !props.onClose) return

  props.onClose()
}

useEscapeKey(props.onClose)
</script>

<template>
  <div
      v-if="isOpen"
      class="modal-overlay"
      @click="handleOverlayClick"
  >
    <div
        class="modal-content"
        @click.stop
    >
      <slot />
    </div>
  </div>
</template>

<style lang="css" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 9999;
}

.modal-content {
  border-radius: 8px;
  padding: 24px;
  position: relative;
  margin-top: -400px;
}
</style>